import * as types from '../constants/idpAdminActions';
import {createOidcClientCredentialsApi, createSbaAppApi, RESULT} from "../api/api";
import {ADD_SP_METADATA_SAVED, CANCEL_ADD_SAML} from "../constants/postMessages";
import {OIDC_APPLICATION} from "../constants/applicationTypes.js";
import {
  DEFAULT_REDIRECT_URI_TYPE,
  OIDC_CLIENT_ID_ALREADY_IN_USE,
  OIDC_CLIENT_ID_OR_CLIENT_SECRET_IS_NOT_VALID
} from "../constants/oidcConstants";
import {postToHost, sessionExpired} from "./auth";

export const generateOidcClientCredentialsStart = () => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_START
});
export const generateOidcClientCredentialsSuccess = (response) => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS,
  response
});
export const generateOidcClientCredentialsFail = () => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL
});

export function generateOidcClientCredentials() {
  return (dispatch) => {
    dispatch(generateOidcClientCredentialsStart());
    return createOidcClientCredentialsApi()
    .then(result => {
      if (result.kind === RESULT.OK) {
        dispatch(generateOidcClientCredentialsSuccess(result.body));
      } else if (result.kind === RESULT.SESSION_EXPIRED) {
        dispatch(sessionExpired());
      } else {
        dispatch(generateOidcClientCredentialsFail());
      }
    });
  }
}

export const addOidcStart = () => ({
  type: types.ADD_OIDC_APP_START
});
export const addOidcSuccess = () => ({
  type: types.ADD_OIDC_APP_SUCCESS
});
export const addOidcFail = (failure) => ({
  type: types.ADD_OIDC_APP_FAIL,
  failure,
});

const isRejectedCredentials = (code) =>
    code === OIDC_CLIENT_ID_ALREADY_IN_USE || code === OIDC_CLIENT_ID_OR_CLIENT_SECRET_IS_NOT_VALID;

export function addOidc() {
  return (dispatch, getState) => {
    const {applicationName, clientId, clientSecret, signature, isPublicClient, oidcRedirectUris} = getState().sp;
    const newMeta = {
      name: applicationName.trim(),
      applicationType: OIDC_APPLICATION,
      oidcProfile: {
        clientId,
        clientSecret,
        signature,
        isPublicClient,
        oidcRedirectUris: oidcRedirectUris.filter(uri => uri.redirectUri.length > 0),
      },
    };
    dispatch(addOidcStart());
    return createSbaAppApi(newMeta)
    .then(result => {
      if (result.kind === RESULT.OK) {
        dispatch(addOidcSuccess());
        dispatch(postToHost(ADD_SP_METADATA_SAVED));
      } else if (result.kind === RESULT.SESSION_EXPIRED) {
        dispatch(sessionExpired());
      } else {
        dispatch(addOidcFail(result));
        if (isRejectedCredentials(result.code)) {
          dispatch(generateOidcClientCredentials());
        }
      }
    });
  }
}

export function cancelAddApp() {
  return (dispatch) => {
    dispatch(postToHost(CANCEL_ADD_SAML));
  }
}

export const updateAppName = (payload) => ({
  type: types.UPDATE_APP_NAME,
  payload
});

export const updateIsPublicClient = (value) => ({
  type: types.UPDATE_IS_PUBLIC_CLIENT,
  value
});

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES,
});

export const setErrorMessage = (errorMsg) => ({
  type: types.SET_ERROR_MESSAGE,
  errorMsg
});

export const addOidcRedirectUri = () => ({
  type: types.ADD_OIDC_REDIRECT_URI,
  newOidcRedirectUri: {
    redirectUri: "",
    redirectUriType: DEFAULT_REDIRECT_URI_TYPE,
  }
});

export const deleteOidcRedirectUri = (targetOidcRedirectUri) => ({
  type: types.DELETE_OIDC_REDIRECT_URI,
  targetOidcRedirectUri
});

export const updateOidcRedirectUri = (payload) => ({
  type: types.UPDATE_OIDC_REDIRECT_URI,
  payload
});
